import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "react-query";
import { Put } from "../utils/api";
import { Order } from "../../types/api/Order";

interface PaymentTerms {
  is_net_30: boolean;
}

export default (orderId: string, orgId: string, buyerOrgId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Order, null, PaymentTerms>(
    `update_payment_terms`,
    async (body: PaymentTerms) => {
      return await Put<Order>(
        `/api/order/${orderId}/payment_terms`,
        await getAccessTokenSilently(),
        body
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(`current_cart_${orgId}_${buyerOrgId}`);
      },
    }
  );
};
